import React, { useEffect, useState } from 'react';
import { SettingsState } from '../../../organisms/SelectSettings';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';

import { makeStyles, createStyles } from '@material-ui/core/styles';
import {
  GetEMCSettings,
  EMCSettingType,
  CreateSettingCombBoxItems,
  CheckEMCSettingEditFlg,
  PutEMCSettings,
  CheckInputData,
} from '../../../../function/EMCModel';
import EMCSettingGrid from './EMCSettingGrid';

import { GetNameDevSetEMCList, NAME_DEV_SET } from '../../../../function/NameDevSetModel';

import { ComboBoxItemTypeSOD } from './../../../atoms/ComboBox/ItemComboBoxStrOD';
import EMCSettingFooter from './EMCSettingFooter';
import ConfirmDialog, { ConfirmDialogResponse } from '../../../atoms/Dialog/ConfirmDialog';
import MessageDialog, { MessageDialogResponse } from '../../../atoms/Dialog/MessageDialog';
import { useModal } from '../../../../function/useModal';
import { ResponceDataType, ErrorCode } from '../../../../ErrorCode';

type EMCSettingPageProps = { editData: SettingsState };

const useStyles = makeStyles(
  createStyles({
    tableContainer: {
      maxHeight: 'calc(100vh - 316px)',
    },
    paper: {
      background: '#FFFFEE',
    },
  })
);

const EMCSettingPage: React.FC<EMCSettingPageProps> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [emcSettingData, setEMCSettingData] = useState<{ settings: EMCSettingType[]; cmbItems: ComboBoxItemTypeSOD[] }>(
    {
      settings: [],
      cmbItems: [],
    }
  );
  const [flgCfmDlg, actCfmDlg] = useModal<ConfirmDialogResponse>();
  const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();

  const [dlgmsg, setDlgmsg] = useState<string>('');
  const [buttonEnable, setButtonEnable] = useState<boolean>(true);

  const cfmdlg = flgCfmDlg ? (
    <ConfirmDialog
      dialog={actCfmDlg}
      message={dlgmsg}
      action={t('EMCSettingPage.はい', 'はい')}
      cancel={t('EMCSettingPage.いいえ', 'いいえ')}
    />
  ) : null;

  const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;

  useEffect(() => {
    props.editData.SaveFunction = saveAction2;
    props.editData.IsUpdate = false;
  }, [props.editData.CancelCondition]);
  /**
   * 初期表示　useEffect
   */
  useEffect(() => {
    upDatePage();
  }, []);

  /**
   * 画面更新
   */
  const upDatePage = () => {
    //console.debug(['EMCSettingPage - useEffect']);
    setButtonEnable(false);
    let emcList: EMCSettingType[] = [];
    let nameDevSetList: NAME_DEV_SET[] = [];
    GetEMCSettings()
      .then((r: EMCSettingType[]) => {
        //console.debug(['EMCSettingPage - useEffect - GetEMCSettings', r]);
        //setEMCSettingList(r);
        emcList = r;
        return GetNameDevSetEMCList();
      })
      .then((r) => {
        console.debug(['EMCSettingPage - useEffect - GetNameDevSetEMCList', r, emcList]);
        nameDevSetList = r;
        let cmdItems = CreateSettingCombBoxItems(emcList, nameDevSetList, t);

        console.debug([
          'EMCSettingPage - useEffect - setEMCSettingList({ settings: emcList, cmbItems: cmdItems })',
          emcList,
          cmdItems,
        ]);
        setEMCSettingData({ settings: emcList, cmbItems: cmdItems });
      })
      .catch((e) => {
        setDlgmsg(t('EMCSettingPage.データ取得中にエラーが発生しました', 'データ取得中にエラーが発生しました'));
        actMsgDlg.open();
        console.error(['EMCSettingPage - useEffect - Error', e, emcList]);
      })
      .finally(() => {
        setButtonEnable(true);
      });
  };

  /**
   * 設定内容変更event
   * @param value
   */
  const onEMCSettingDataChange = (value: EMCSettingType) => {
    emcSettingData.settings.map((r) => {
      if (r.indexNo === value.indexNo) {
        r.isEdit = true; //変更フラグON
        r.RunFlg = value.RunFlg;
        r.DEV_INDEX = value.DEV_INDEX;
      }
      return r;
    });
    setEMCSettingData({ settings: emcSettingData.settings, cmbItems: emcSettingData.cmbItems });

    props.editData.Target = emcSettingData.settings;
    props.editData.IsUpdate = true;
  };

  /**
   * 保存ボタンアクション
   */
  const saveAction = () => {
    if (CheckEMCSettingEditFlg(emcSettingData.settings)) {
      let message = CheckInputData(emcSettingData.settings, t);
      console.debug(['重複エラー', message]);
      if (message.length !== 0) {
        setDlgmsg(message.join('\n'));
        actMsgDlg.open();
        return;
      }
      setDlgmsg(t('EMCSettingPage.変更内容を保存しますか', '変更内容を、保存しますか?'));
      actCfmDlg
        .open()
        .apply((_) => {
          setButtonEnable(false);
          console.debug(t('EMCSettingPage.実行', '実行'));
          PutEMCSettings(emcSettingData.settings)
            .then((r: ResponceDataType) => {
              if (r.ErrorCode === ErrorCode.ERR_CODE_NONE) {
                setDlgmsg(t('EMCSettingPage.設定を保存しました', '設定を保存しました'));
                actMsgDlg.open();
                upDatePage(); //再描画
                props.editData.IsUpdate = false;
              } else {
                setDlgmsg(t('EMCSettingPage.設定を保存できませんでした', '設定を保存できませんでした'));
                console.error(['PutEMCSettings error ', r]);
                actMsgDlg.open();
              }
            })
            .catch((e) => {
              setDlgmsg(t('EMCSettingPage.保存中にエラーが発生しました', '保存中にエラーが発生しました'));
              actMsgDlg.open();
              console.error(['PutEMCSetting - useEffect - Error', e]);
            })
            .finally(() => {
              setButtonEnable(true);
            });
        })
        .cancel(() => {
          console.debug(t('EMCSettingPage.キャンセル', 'キャンセル'));
        });
    } else {
    }
  };

  /**
   * タブ切替時に動作
   * @param param
   * @returns
   */
  const saveAction2 = (param: object): Promise<string> => {
    return new Promise((resolve, reject) => {
      const sp = param as EMCSettingType[];
      console.debug(['★saveAction2', param]);
      if (CheckEMCSettingEditFlg(sp)) {
        let message = CheckInputData(sp, t);
        console.debug(['重複エラー', message]);
        if (message.length !== 0) {
          setDlgmsg(message.join('\n'));
          actMsgDlg.open();
          reject('data error');
          return;
        }
      }

      setButtonEnable(false);
      console.debug(t('EMCSettingPage.実行', '実行'));
      PutEMCSettings(sp)
        .then((r: ResponceDataType) => {
          if (r.ErrorCode === ErrorCode.ERR_CODE_NONE) {
            console.debug('saveAction ok');
            resolve('done');
          } else {
            setDlgmsg(t('EMCSettingPage.設定を保存できませんでした', '設定を保存できませんでした'));
            console.error(['PutEMCSettings error ', r]);
            actMsgDlg.open();
            reject('data error');
          }
        })
        .catch((e) => {
          setDlgmsg(t('EMCSettingPage.保存中にエラーが発生しました', '保存中にエラーが発生しました'));
          actMsgDlg.open();
          reject('data error');
          console.error(['PutEMCSetting - useEffect - Error', e]);
        })
        .finally(() => {
          setButtonEnable(true);
        });
    });
  };

  /**
   * キャンセルボタンアクション
   */
  const cancelAction = () => {
    if (CheckEMCSettingEditFlg(emcSettingData.settings)) {
      setDlgmsg(
        t(
          'EMCSettingPage.保存していないデータを破棄します。\nよろしいですか?',
          '保存していないデータを破棄します。\nよろしいですか?'
        )
      );
      actCfmDlg
        .open()
        .apply((_) => {
          upDatePage(); //再描画
          props.editData.UpdateCancel();
          console.debug(t('EMCSettingPage.実行', '実行'));
        })
        .cancel(() => {
          console.debug(t('EMCSettingPage.キャンセル', 'キャンセル'));
        });
    } else {
    }
  };

  return (
    <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ margin: 2 }}>
      <Grid item xs={12}>
        <EMCSettingGrid
          tableStyle={classes.tableContainer}
          emcSettingList={emcSettingData.settings}
          cmoboBoxItemList={emcSettingData.cmbItems}
          onChangeEvent={onEMCSettingDataChange}
        ></EMCSettingGrid>
      </Grid>
      <Grid item xs={12}>
        <EMCSettingFooter
          onClickSaveButton={saveAction}
          onClickCancelButton={cancelAction}
          buttonEnable={buttonEnable}
        ></EMCSettingFooter>
      </Grid>
      {cfmdlg}
      {msgdlg}
    </Grid>
  );
};
export default EMCSettingPage;
